/* eslint-disable @typescript-eslint/consistent-type-assertions */
import Keycloak from 'keycloak-js';

export const keycloakConfig = <Keycloak.KeycloakConfig>{
    url: (window as any).app.env.REACT_APP_AUTH_URL || process.env.REACT_APP_AUTH_URL,
    realm: (window as any).app.env.REACT_APP_AUTH_REALM || process.env.REACT_APP_AUTH_REALM,
    clientId: (window as any).app.env.REACT_APP_AUTH_CLIENTID || process.env.REACT_APP_AUTH_CLIENTID,
};

export const keycloakInstance = new Keycloak(keycloakConfig);

// eslint-disable-next-line import/no-default-export
export default keycloakInstance;
